export const connectors = ["SAE-J1772", "Tipo 2", "GB/T"];